import React from 'react';
import { Select, SelectProps } from 'antd';

import { useQuery } from 'react-query';
import { getThirdPartyAuthorizationListByTpid } from 'services/thirdParty';
import { noop } from 'lodash';
import { toCurrency } from 'utils/utils';

export type TpAuthorizationSelectProps  = SelectProps<any> & {
  tpid: number;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  onSelected?: any;
  activedata?:boolean
};

const TpAuthorizationSelect = ({
  tpid,
  onSelected,
  onChange = noop,
  activedata,
  ...otherProps
}: TpAuthorizationSelectProps) => {
  const { data, refetch } = useQuery(
    ['getThirdPartyAuthorizationListByTpid', { tpid: Number(tpid) }],
    () =>
      getThirdPartyAuthorizationListByTpid({ tpid: Number(tpid) }).then(
        (res) => res.list || []
      ),
    { enabled: !!tpid }
  );
  const activedatalist=data?.filter((e)=>e.authstatus==='ACTIVE')

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected) {
      onSelected(data?.find((item) => item.authid === value)!);
    }
  };
  return (
    <Select {...otherProps} onChange={handleChange}>
      {activedata?(activedatalist?.map((tpauth) => (
        <Select.Option value={tpauth.authid} key={tpauth.authid}>
          {tpauth.authid + ' - ' + tpauth.authtypelabel + ' - ' + tpauth.authstatus + ' - ' + toCurrency(tpauth.authavailableamount,tpauth.currcode??localStorage.getItem('currcode') ?? '')}
        </Select.Option>
      ))):(data?.map((tpauth) => (
        <Select.Option value={tpauth.authid} key={tpauth.authid}>
          {tpauth.authid + ' - ' + tpauth.authtypelabel + ' - ' + tpauth.authstatus + ' - ' + toCurrency(tpauth.authavailableamount,tpauth.currcode??localStorage.getItem('currcode') ?? '')}
        </Select.Option>
      )))}
      
    </Select>
  );
};

export default TpAuthorizationSelect;
